export const questionnaireSections = [
  {
    id: 'A',
    title: 'Zapojení a aktivita v lekci',
    questions: [
      {
        id: 'A1',
        text: 'Zapojil jsem se aktivně?',
        options: ['ne', 'spíš ne', 'napůl', 'spíš ano', 'ano']
      },
      {
        id: 'A2',
        text: 'Učil jsem se s chutí?',
        options: ['ne', 'spíš ne', 'napůl', 'spíš ano', 'ano']
      },
      {
        id: 'A3',
        text: 'Mám chuť učit se dál?',
        options: ['ne', 'spíš ne', 'napůl', 'spíš ano', 'ano']
      }
    ]
  },
  {
    id: 'B',
    title: 'Soustředění a učení - ve srovnání s minulou lekcí',
    questions: [
      {
        id: 'B1',
        text: 'Soustředil jsem se lépe v oproti minulé lekci?',
        options: ['ne', 'spíš ne', 'stejně', 'spíš ano', 'ano']
      },
      {
        id: 'B2',
        text: 'Bylo jednodušší si zapamatovat nová slovíčka?',
        options: ['ne', 'spíš ne', 'stejně', 'spíš ano', 'ano']
      },
      {
        id: 'B3',
        text: 'Byly úkoly náročnější? (např. sestavování vět):',
        options: ['ne', 'spíš ne', 'stejné', 'spíš ano', 'ano']
      }
    ]
  },
  {
    id: 'C',
    title: 'Celkový dojem z lekce - ve srovnání s minulou lekcí',
    questions: [
      {
        id: 'C1',
        text: 'Pracovalo se mi lépe oproti minulé lekci?',
        options: ['ne', 'spíš ne', 'stejně', 'spíš ano', 'ano']
      }
    ]
  }
];